import { BaseUrl, FormConfig, JsonConfig, UserName, jwtToken } from "./BaseRepository";
import axios from 'axios';

//Api request for Fetching Off Cycle data for Grid
export const FetchAllOffCycleData = async () => {
    try{
        const URL = BaseUrl + "OffCycle/getoffcycledata";
        const Response = await axios.get(URL, JsonConfig);
        const JsonResponse = Response != null ? Response.data: null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}

//Api request for Fetching Off Cycle data for Grid
export const FetchHistoricOffCycleData = async (PayDate, ProcessedDate) => {
    try{
        let Bodydata = {
            Pay_Date: PayDate,
            Processed_Date: ProcessedDate
        }
        const URL = BaseUrl + "OffCycle/getoffcyclehistoricdata";
        const Response = await axios.post(URL, Bodydata,JsonConfig);
        const JsonResponse = Response != null ? Response.data: null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}


//Api request for Fetching  Off Cycle data for Grid
export const FetchAllOffCycleCodesAndHeaders = async () => {
    try{
        const URL = BaseUrl + "OffCycle/offcycleheaderscodes";
        const Response = await axios.get(URL, JsonConfig);
        const JsonResponse = Response != null ? Response.data: null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}

//Api request for Updating Off Cycle data for Grid
export const UpdateOffCycleData = async (UpdatedData) => {
    try{
        let offDataJson = JSON.stringify(UpdatedData);
        const URL = BaseUrl + "OffCycle/updatesingleoffcycle";
        const Response = await axios.put(URL, {Data:offDataJson}, JsonConfig);
        const JsonResponse = Response != null ? Response.data: null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}

//Api request for Updating Off Cycle data for Grid
export const AddOffCycleData = async (NewRecord) => {
    try{
        let offDataJson = JSON.stringify(NewRecord);
        const URL = BaseUrl + "OffCycle/addsingleoffcycle/"+UserName;
        const Response = await axios.post(URL, {Data:offDataJson}, JsonConfig);
        const JsonResponse = Response != null ? Response.data: null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}

//Api request for Fetching  Off Cycle data for Grid
export const DeleteOffCycleData = async (id) => {
    try{
        const URL = BaseUrl + "OffCycle/deletesingleoffcycle/"+id;
        const Response = await axios.delete(URL, JsonConfig);
        const JsonResponse = Response != null ? Response.data: null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}

//Api request for Updating Off Cycle data for Grid
export const UploadOffCycleData = async (File, UserName) => {
    try{
        // let offDataJson = JSON.stringify(NewRecord);
        const URL = BaseUrl + "OffCycle/uploadoffcycle?userName="+UserName;
        const Response = await axios.post(URL, File, FormConfig);
        const JsonResponse = Response != null ? Response.data: null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}

export const FetchFileNumberData = async (FileNumber) => {
    try {
        const URL = BaseUrl + "OffCycle/getfilenumberdata/"+FileNumber;
        const Response = await axios.get(URL, JsonConfig);
        const JsonResponse = Response != null ? Response.data: null;
        return JsonResponse;
    }
    catch{
        return null;
    }
}